import axios from 'axios';

export interface ObserveSiteUsage {
  siteName: string | null;
  stations: { id: string; name: string; installationId: string | null }[];
}

export interface ObserveApp {
  appUrl: string;
  scope: string;
}

export interface ObserveConfigFiles {
  siteName: string;
  files: { name: string; content: string }[];
}

// Cobrick Observe lives in scaleo-backend; scaleo-admin-backend only forwards these calls.
class ObserveService {
  async provisionSite(stationId: string) {
    return axios.post<{ observeSite: string | null }>(`/stations/observe-site`, { id: stationId });
  }

  async getSiteUsage(stationId: string) {
    return axios.get<ObserveSiteUsage>(`/stations/observe-site/usage/${stationId}`);
  }

  async deleteSite(stationId: string) {
    return axios.delete<{ siteName: string; stationIds: string[] }>(`/stations/observe-site/${stationId}`);
  }

  // Null when the integration is not configured on this environment.
  async getApp() {
    return axios.get<ObserveApp | null>(`/stations/observe-app`);
  }

  async getConfigFiles(stationId: string) {
    return axios.get<ObserveConfigFiles>(`/stations/observe-config/${stationId}`);
  }
}

const observeService = new ObserveService();

export default observeService;
